<style scoped>

</style>

<template>
    <div :id="config.id"></div>
</template>

<script>
  import Player from 'xgplayer';
  export default {
    name: "Player",
    props: {
      options: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      let defaultOptions = {
        id: 'video-player',
        fluid: true,
        playbackRate: [0.5, 0.75, 1, 1.5, 2],
        lang: 'zh-cn'
      };
      return {
        config: Object.assign({}, defaultOptions, this.options),
        player: null
      }
    },
    methods: {
      init() {
        var self=this;
        console.log(Player);
        if (this.config.url && this.config.url !== '') {
            if(this.config.url.indexOf('m3u8')>-1){
                this.player = new window.HlsJsPlayer(this.config);
            }else{
                this.player = new Player(this.config);
            }
            this.player.once('complete',()=>{
             self.$emit('initPlayer', self.player)
            })
        }
      }
    },
    mounted() {
      this.init();
    },
    beforeUpdate() {
      this.init();
    },
    beforeDestroy() {
      this.player && typeof this.player.destroy === 'function' && this.player.destroy();
    }
  }
</script>